import type * as React from 'react';

import { routeColor } from '@/lib/mbta/route-color';
import { cn } from '@/lib/utils';
import type { RouteRead } from '@/types';

interface RouteBadgeProps {
  route?: Pick<RouteRead, 'id' | 'long_name' | 'short_name' | 'color'> | null;
  routeId?: string | null;
  label?: string;
  className?: string;
}

export function RouteBadge({
  route,
  routeId,
  label,
  className,
}: RouteBadgeProps): React.JSX.Element {
  const id = route?.id ?? routeId ?? '';
  const text = label ?? route?.short_name ?? route?.long_name ?? id;
  const color = routeColor(route ?? id);
  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 rounded-full border border-border bg-surface px-2.5 py-1 text-caption font-medium',
        className,
      )}
      aria-label={`Route ${text}`}
    >
      <span
        aria-hidden="true"
        className="h-2.5 w-2.5 rounded-full"
        style={{ backgroundColor: color }}
      />
      <span className="min-w-0 truncate">{text}</span>
    </span>
  );
}
